import React, { ReactElement } from 'react';
import '../style.scss';
// import './style.scss';
import { Button, ButtonFill, ButtonSize, } from 'views/mutual/button';
import { CorporateAccountOpenProfileDetailsPages, useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';
import { Caption } from 'views/mutual/caption';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { TemplateProps } from '../common';

export const SpecialInvestorConfirm = ({
  isUpdate,
}: TemplateProps) => {
  useCustomLocationName('口座開設');
  const { setAccountOpenProfileDetailsPageType, previousPage } = useCorporateAccountOpenProfileDetailsPageTypeStore();
  return (
    <div className="accountOpenTemplate">
    {!isUpdate && <Caption label="一般投資家への移行" />}
      {!isUpdate && (
        <div className="accountOpenTemplate_button">
          <div className="accountOpenTemplate_input">
            お客様を、特定投資家のままお取り扱いいたします。なお、特定投資家であっても、一般投資家と同じご契約フローとなりますので、適合性チェック、契約締結前交付書面のご確認をお願いすることになります。
          </div>
          <br/>
          <Button
            label={isUpdate ? '登録情報の変更' : '申込内容の確認へ進む'}
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.medium}
            onClick={() => setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.tfAuthentication)}
          />
          <Button
            label="前の画面に戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.small}
            onClick={() => {console.log(`previousPage : ${previousPage}`); setAccountOpenProfileDetailsPageType(previousPage)}}
          />
        </div>
      )}
    </div>
  );
};
